import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import pdf from "../../Assets/Afreul-Kaium-Joy_Resume-01.pdf";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";

function Home() {
  return (
    <>
      <Particle />
      <Container className="home-content">
        <Row>
          <Col md={8} className="home-header">
            <h1  className="heading">
              Hi There!{" "}
              <span className="wave" role="img" aria-labelledby="wave">
                👋🏻
              </span>
            </h1>

            <h1 className="heading-name">
              I'M
              <strong className="main-name"> AFreul Joy</strong>
            </h1>

            <div className="designation">
              <Type />
            </div>
            <br />
            <br />
            <Button id="cv" variant="light" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;See My CV
          </Button>
          </Col>

          <Col md={4} style={{ paddingBottom: 20 }}>
            <img src={homeLogo} alt="home pic" className="img-fluid rounded" />
          </Col>
        </Row>
      </Container>

      <Home2 />
    </>
  );
}

export default Home;
